import { GlobalAccess } from "../services/workspaces/global.access";
import type {
  CreateWorkspaceDetails,
  DuplicateWorkspaceDetails,
} from "../state/workspaces/types";
import { defaultModule } from "./defaultModule";

export const defaultWorkspaceName = "New workspace";
export const defaultGlobalAccess: GlobalAccess = GlobalAccess.NONE;

export const getCreateFromTemplatePayload = (
  workspaceId: string,
  selectedProjectId: string | undefined,
): DuplicateWorkspaceDetails => ({
  workspaceId,
  containerId: selectedProjectId,
  open: true,
  workspaceName: defaultWorkspaceName,
  globalAccess: defaultGlobalAccess,
});

export const getCreateBlankWorkspacePayload = (): CreateWorkspaceDetails => ({
  globalAccess: defaultGlobalAccess,
  module: { name: defaultModule },
  workspaceName: defaultWorkspaceName,
});
